export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9090.8ddb88f6.jpg";